import React from "react";
import Card from "../../newComponents/card";

const relatedCard = ({block}) => {

  const styles = `lg:float-${block.align} lg:min-w-1/3 lg:w-1/3 clear-${block.align}`;
  const item = block.relatedEntry[0];
  let finalCard;

  switch(block.relatedEntry[0].sectionHandle) {
    case "staff":
      finalCard = <Card className={styles} image={item.featureImage[0]} ar={1/1} title={item.displayTitle} subtitle={item.position} href={`/${item.uri}`}/>;
      break;
    case "news":
      finalCard = <Card className={styles} image={item.featureImage[0]} ar={1/1} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`}/>;
      break;
    case "projects":
      finalCard = <Card className={styles} image={item.featureImage[0]} ar={1/1} title={item.title} subtitle={item.summary} href={`/${item.uri}`} color={1}/>;
      break;
    case "resources":
      finalCard = <Card className={styles} image={item.featureImage[0]} ar={2} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`} color={1}/>;
      break;
    case "page":
      finalCard = <Card className={styles} image={item.featureImage[0]} ar={2} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`}/>
      break;
    default:
      finalCard = <div>Hello, World!</div>;
      break;
  }

  return (
    <section>
      <div className="shell">
        {finalCard}
      </div>
    </section>
  );
} 

export default relatedCard;